var map = {
	"./bubble_1.png": "2217",
	"./bubble_2.png": "b08f",
	"./bubble_3.png": "f0fd",
	"./dice_1.png": "9302",
	"./dice_2.png": "fc34",
	"./dice_3.png": "ea69",
	"./dice_4.png": "30a3",
	"./dice_5.png": "6047",
	"./dice_6.png": "c3b0",
	"./dice_step_1.png": "36c3",
	"./dice_step_2.png": "096e",
	"./empty.png": "42a5",
	"./gum1.png": "eaf6",
	"./gum2.png": "35e0",
	"./hand.png": "544f",
	"./jour.gif": "98b8",
	"./nuit.gif": "3fb7",
	"./pie_branch.png": "fc64",
	"./pie_coin.png": "8957",
	"./pie_diamond.png": "af87",
	"./pie_leave.png": "d22f",
	"./pie_necklace.png": "ed45",
	"./skeleton_1.png": "4d17",
	"./skeleton_2.png": "f2a5",
	"./x_ray_1.png": "2209",
	"./x_ray_2.png": "4639",
	"./x_ray_3.png": "e262",
	"./x_ray_4.png": "2953",
	"./x_ray_5.png": "0f19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "199b";